import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-48 max-w-[40rem] mx-auto" }
const _hoisted_2 = { class: "text-3xl font-black" }
const _hoisted_3 = { class: "flex flex-wrap items-center font-bold gap-1" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-normal" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex flex-col gap-2 py-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex gap-4 items-center"
}
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "flex gap-4 items-center" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "flex gap-4 items-center" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Job description", -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  id: "description-modal",
  expand: "block",
  class: "opacity-70 underline"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Job description", -1)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Requirements", -1)
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 0,
  id: "requirements-modal",
  expand: "block",
  class: "opacity-70 underline"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Requirements", -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Roles & Responsibilites", -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 0,
  id: "roles-modal",
  expand: "block",
  class: "opacity-70 underline"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Roles & Responsibilites", -1)
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "flex flex-col max-w-[40rem] mx-auto px-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-job pr-3" }, null, -1)

import numeral from "numeral"
  import { forEach, head } from "lodash"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useAccountStore } from "@/store/account"
  import { useCompanyStore } from "@/store/company"
  import { record } from "@/utils/analytics"
  import { useMetadataStore } from "@/store/metadata"
  import { ref, watch, onBeforeMount, computed, onMounted } from "vue"
  import { arrowBackCircle, arrowRedo, heartOutline } from "ionicons/icons"
  import { IonButton, IonPage, IonLoading } from "@ionic/vue"
  import { toastController } from "@ionic/core"
  import router from "@/router"
  import { useRoute } from "vue-router"
  import dateParser from "@/utils/dateParser"
  import { useGtm } from "@gtm-support/vue-gtm"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import DetailsContainer from "@/components/job-page/DetailsContainer.vue"
  import ToolsNeeded from "@/components/job-page/ToolsNeeded.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  import JobPage from "@/views/job-board/JobPost.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'JobPost',
  setup(__props) {

  const metadata = useMetadataStore()
  const companyStore = useCompanyStore()
  const route = useRoute()
  const gtm = useGtm()

  const loading = ref(false)
  const ownerEmail = ref("")
  const jobDetails = computed(() => companyStore.jobDetails)
  const companyDetails = computed(() => companyStore.companyDetails)
  const followed = computed(() => {
    const follows: string[] = jobDetails.value.follows || []
    return follows.includes(useAccountStore().account_id) || false
  })
  const quickActionDetails = computed(() => {
    let datePosted = ""

    if (jobDetails.value.updated) datePosted = dateParser.computeDistanceToNow(jobDetails.value.updated)
    else if (jobDetails.value.created) datePosted = dateParser.computeDistanceToNow(jobDetails.value.created)
    else datePosted = "Date Unspecified"

    return {
      job: jobDetails.value.title,
      companyId: companyDetails.value.company_id,
      companyName: companyDetails.value.name,
      companySlug: companyDetails.value.slug,
      type: jobDetails.value.type,
      applyLink: jobDetails.value.apply_link || "",
      slug: jobDetails.value.slug || router.currentRoute.value.params.slug,
      address: companyDetails.value.location.city + ", " + companyDetails.value.location.country,
      date: datePosted,
      urgent: jobDetails.value.urgent || false,
      image: companyDetails.value.logo,
      color: companyDetails.value.brand_color,
    }
  })
  const toolsList = computed(() => {
    const newArray = [] as any
    forEach(jobDetails.value.tech_stack, (value) => {
      newArray.push({ name: value })
    })
    return newArray
  })
  const companyHighlights = computed(() => [
    {
      title: companyDetails.value.location && companyDetails.value.location.city ? companyDetails.value.location.city : "N/A",
      description: "Location",
      icon: "workbean-building",
    },
    {
      title: companyDetails.value.year_founded ? companyDetails.value.year_founded : "N/A",
      description: "Year founded",
      icon: "workbean-idea",
    },
    {
      title: companyDetails.value.number_of_employees ? companyDetails.value.number_of_employees : "N/A",
      description: "Employee count",
      icon: "workbean-group-user",
    },
    {
      title: companyDetails.value.company_type ? companyDetails.value.company_type : "N/A",
      description: "Company type",
      icon: "workbean-world",
    },
    {
      title: companyDetails.value.work_setup ? companyDetails.value.work_setup : "N/A",
      description: "Work setup",
      icon: "workbean-job",
    },
  ])
  const jobHighlights = computed(() => [
    {
      title: jobDetails.value.condition && jobDetails.value.condition.employment_type ? jobDetails.value.condition.employment_type : "N/A",
      description: "Employee type",
      icon: "workbean-group-user",
    },
    {
      title: jobDetails.value.application && jobDetails.value.application?.min_exp ? jobDetails.value.application.min_exp + " years" : "N/A",
      description: "Minimum experience",
      icon: "workbean-star",
    },
    {
      title: head(jobDetails.value.department) ? head(jobDetails.value.department) : "N/A",
      description: "Department",
      icon: "workbean-job",
    },
    {
      title: jobDetails.value.application && jobDetails.value.application.vacancy ? jobDetails.value.application.vacancy : "N/A",
      description: "Available position",
      icon: "workbean-job",
    },
  ])

  /**
   * Copies the current URL of the job post to clipboard
   */
  const copyToCLipboard = async () => {
    navigator.clipboard.writeText(window.location.href)
    const toast = await toastController.create({
      message: "Job link copied to clipboard successfully!",
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }

  /**
   * redirect back to job board
   */
  const back = () => {
    window.location.href = "/job-board"
  }
  /**
   * Follow job post
   */
  const followJob = async () => {
    if (!localStorage.getItem("WBSAASAPP_TK")) {
      useAuthenticationStore().authenticationWall = true
    } else {
      await companyStore.follow("job", jobDetails.value.slug)
      await companyStore.retrieveJobPost(router.currentRoute.value.params.slug as string)
    }
  }

  /**
   * @number - either number or string
   * return the number with comma
   */
  const numberWithComma = (number: number | string) => {
    return numeral(number).format("0,0")
  }

  let windowAction = setTimeout(() => {
    // window action will add here
  }, 300)
  /**
   * @param link - link to open (string)
   * @param target - target to open link (string)
   *
   * open apply link
   */
  const applyNow = async (link: string, target?: string) => {
    record({
      event: "ApplyNowClicks",
      attributes: {
        link: window.location.href,
        job_slug: quickActionDetails.value.slug,
        company_id: quickActionDetails.value.companyId,
        company_slug: quickActionDetails.value.companySlug,
        job_type: quickActionDetails.value.type,
        via: "Job Page",
      },
    })
    if (gtm?.enabled()) {
      gtm.trackEvent({
        event: "apply_now_clicks",
        label: `apply now clicks from job page`,
        value: `${window.location.href}`,
      })
    }
    clearTimeout(windowAction)
    windowAction = setTimeout(() => {
      window.open(link, target)
    }, 300)
  }
  /**
   * @param link - link to redirect (string)
   *
   * redirect to company page
   */
  const seeCompanyPage = (link: string) => {
    record({
      event: "CompanyRedirects",
      attributes: {
        link: window.location.href,
        job_slug: quickActionDetails.value.slug,
        company_id: quickActionDetails.value.companyId,
        company_slug: quickActionDetails.value.companySlug,
        job_type: quickActionDetails.value.type,
        via: "Job Page",
      },
    })
    if (gtm?.enabled()) {
      gtm.trackEvent({
        event: "company_redirects",
        label: `company redirects from job page`,
        value: `${window.location.href}`,
      })
    }
    clearTimeout(windowAction)
    windowAction = setTimeout(() => {
      router.push(link)
    }, 300)
  }

  onBeforeMount(async () => {
    await companyStore.retrieveJobPost(router.currentRoute.value.params.slug as string)
    if (jobDetails.value.status !== "published") window.location.href = "/not-found"
    if (!quickActionDetails.value.applyLink.length) {
      ownerEmail.value = await companyStore.getApplyEmail(quickActionDetails.value.slug as string)
    }
  })

  onMounted(async () => {
    loading.value = true
    await companyStore.retrieveCompanyDetails(router.currentRoute.value.params.company as string)
    loading.value = false
    record({
      event: "JobViewPage",
      attributes: {
        link: route.fullPath,
        job_id: companyStore.jobDetails.job_id,
        company_id: companyStore.companyDetails.company_id,
      },
    })
  })

  watch([jobDetails, companyDetails], () => {
    metadata.details.title = jobDetails.value.title + " at " + companyDetails.value.name
    metadata.details.description = companyDetails.value.tagline
    metadata.details.og.title = jobDetails.value.title + " at " + companyDetails.value.name
    metadata.details.og.description = companyDetails.value.tagline
    metadata.details.twitter.title = jobDetails.value.title + " at " + companyDetails.value.name
    metadata.details.twitter.description = companyDetails.value.tagline
    metadata.details.og.canonical = window.location.href
    metadata.details.twitter.image = jobDetails.value.display_link ? jobDetails.value.display_link : (companyDetails.value.cover_photo as string)
    metadata.details.og.image = jobDetails.value.display_link ? jobDetails.value.display_link : (companyDetails.value.cover_photo as string)
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLoading), {
            "is-open": loading.value,
            message: "Loading...",
            spinner: null
          }, null, 8, ["is-open"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex", { 'absolute z-10 h-[23rem] max-w-[40rem] w-full mx-auto': _unref(jobDetails).display_link?.length }])
            }, [
              _createVNode(_component_ion_icon, {
                class: "text-3xl text-gray-300 pl-3 py-3",
                icon: _unref(arrowBackCircle),
                onClick: back
              }, null, 8, ["icon"]),
              _createElementVNode("div", {
                class: _normalizeClass(["w-full h-full flex gap-5 justify-end items-end pr-3", { 'flex-col pb-16': _unref(jobDetails).display_link?.length, 'flex-row p-2': !_unref(jobDetails).display_link?.length }])
              }, [
                _createVNode(_component_ion_icon, {
                  id: "heart_button_job_board",
                  class: _normalizeClass(["text-3xl px-2 py-2 bg-primary-black bg-opacity-20 rounded-full heart-button-favorite", { 'text-white': !_unref(followed), 'text-primary-violet': _unref(followed) }]),
                  icon: _unref(heartOutline),
                  onClick: followJob
                }, null, 8, ["class", "icon"]),
                _createVNode(_component_ion_icon, {
                  class: "text-3xl text-white px-2 py-2 bg-primary-black bg-opacity-20 rounded-full",
                  icon: _unref(arrowRedo),
                  onClick: copyToCLipboard
                }, null, 8, ["icon"])
              ], 2)
            ], 2),
            (_unref(jobDetails).display_link?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg-clip-border bg-cover bg-origin-border bg-no-repeat bg-center h-[23rem] w-full flex",
                  style: _normalizeStyle({ 'background-image': `url(${_unref(jobDetails).display_link})` })
                }, null, 4))
              : _createCommentVNode("", true),
            _createVNode(CardTemplate, { class: "mx-3 flex flex-col gap-2" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(jobDetails).title), 1),
                _createElementVNode("span", _hoisted_3, [
                  (_unref(companyDetails).logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "h-7 w-7 rounded-full object-center",
                        src: _unref(companyDetails).logo,
                        alt: ""
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_unref(companyDetails).name) + " • ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(companyDetails).location.city) + ", " + _toDisplayString(_unref(companyDetails).location.country), 1)
                ]),
                (_unref(jobDetails).salary && (_unref(jobDetails).salary.minimum || _unref(jobDetails).salary.maximum))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(jobDetails).salary.currency) + " " + _toDisplayString(_unref(jobDetails).salary.minimum && _unref(jobDetails).salary.minimum !== _unref(jobDetails).salary.maximum ? numberWithComma(_unref(jobDetails).salary.minimum) : "") + " " + _toDisplayString(_unref(jobDetails).salary.minimum && _unref(jobDetails).salary.maximum && _unref(jobDetails).salary.minimum !== _unref(jobDetails).salary.maximum ? " - " : "") + " " + _toDisplayString(_unref(jobDetails).salary.maximum ? numberWithComma(_unref(jobDetails).salary.maximum) : "") + " / month ", 1))
                  : (_unref(jobDetails).type == 'workbean')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Salary range not available"))
                    : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_unref(quickActionDetails).date) + " · ", 1),
                  (_unref(quickActionDetails).urgent)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        style: _normalizeStyle({ color: _unref(companyDetails).brand_color || '#7442c8' })
                      }, "urgently hiring", 4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_unref(jobDetails).type == 'workbean')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createElementVNode("i", {
                          class: "workbean-job text-xl",
                          style: _normalizeStyle({ color: _unref(companyDetails).brand_color || '#7442c8' })
                        }, null, 4),
                        _createTextVNode(" Work setup "),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(jobDetails).condition.work_setup), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("i", {
                      class: "workbean-users text-xl",
                      style: _normalizeStyle({ color: _unref(companyDetails).brand_color || '#7442c8' })
                    }, null, 4),
                    _createTextVNode(" Employment type "),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(jobDetails).condition.employment_type), 1)
                  ]),
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["text-xl", { 'workbean-star': _unref(jobDetails).type == 'workbean', 'workbean-job': _unref(jobDetails).type != 'workbean' }]),
                      style: _normalizeStyle({ color: _unref(companyDetails).brand_color || '#7442c8' })
                    }, null, 6),
                    _createTextVNode(_toDisplayString(_unref(jobDetails).type == "workbean" ? "Minimum Experience" : "Department") + " ", 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(jobDetails).type == "workbean" ? _unref(jobDetails).application?.min_exp : _unref(head)(_unref(jobDetails).department) ? _unref(head)(_unref(jobDetails).department) : "N/A"), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            (_unref(jobDetails).description?.length)
              ? (_openBlock(), _createBlock(CardTemplate, {
                  key: 1,
                  class: "mx-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("p", {
                      class: "wysiwyg",
                      innerHTML: `${_unref(jobDetails).description.slice(0, 299)}${_unref(jobDetails).description.length > 300 ? '...' : ''}`
                    }, null, 8, _hoisted_16),
                    (_unref(jobDetails).description.length > 300)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_17, "See more"))
                      : _createCommentVNode("", true),
                    _createVNode(BottomModal, { type: "description-modal" }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createElementVNode("p", {
                          class: "wysiwyg",
                          innerHTML: _unref(jobDetails).description
                        }, null, 8, _hoisted_19)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(jobDetails).requirements?.length)
              ? (_openBlock(), _createBlock(CardTemplate, {
                  key: 2,
                  class: "mx-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createElementVNode("p", {
                      class: "wysiwyg",
                      innerHTML: `${_unref(jobDetails).requirements.slice(0, 299)}${_unref(jobDetails).description.length > 300 ? '...' : ''}`
                    }, null, 8, _hoisted_21),
                    (_unref(jobDetails).requirements.length > 300)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_22, "See more"))
                      : _createCommentVNode("", true),
                    _createVNode(BottomModal, { type: "requirements-modal" }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _createElementVNode("p", {
                          class: "wysiwyg",
                          innerHTML: _unref(jobDetails).requirements
                        }, null, 8, _hoisted_24)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(jobDetails).roles_responsibility?.length)
              ? (_openBlock(), _createBlock(CardTemplate, {
                  key: 3,
                  class: "mx-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _createElementVNode("p", {
                      class: "wysiwyg",
                      innerHTML: `${_unref(jobDetails).roles_responsibility.slice(0, 299)}${_unref(jobDetails).description.length > 300 ? '...' : ''}`
                    }, null, 8, _hoisted_26),
                    (_unref(jobDetails).roles_responsibility.length > 300)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_27, "See more"))
                      : _createCommentVNode("", true),
                    _createVNode(BottomModal, { type: "roles-modal" }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createElementVNode("p", {
                          class: "wysiwyg",
                          innerHTML: _unref(jobDetails).roles_responsibility
                        }, null, 8, _hoisted_29)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(toolsList)?.length)
              ? (_openBlock(), _createBlock(ToolsNeeded, {
                  key: 4,
                  tools: _unref(toolsList)
                }, null, 8, ["tools"]))
              : _createCommentVNode("", true),
            (_unref(jobDetails).type == 'workbean')
              ? (_openBlock(), _createBlock(DetailsContainer, {
                  key: 5,
                  collection: _unref(jobHighlights),
                  type: "Job details",
                  color: _unref(companyDetails).brand_color || '#7442c8'
                }, null, 8, ["collection", "color"]))
              : _createCommentVNode("", true),
            _createVNode(DetailsContainer, {
              collection: _unref(companyHighlights),
              type: "Company details",
              color: _unref(companyDetails).brand_color || '#7442c8'
            }, null, 8, ["collection", "color"])
          ]),
          _createElementVNode("div", {
            class: "fixed bottom-28 w-full z-20",
            style: _normalizeStyle({ backdropFilter: 'blur(5px)' })
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                class: "text-white font-bold rounded-[4px] shadow-base",
                style: _normalizeStyle({ backgroundColor: _unref(companyDetails).brand_color || '#7442c8' }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              applyNow(
                (_unref(quickActionDetails).type === 'lever' || _unref(quickActionDetails).type === 'bamboohr') && _unref(quickActionDetails).applyLink.length
                  ? _unref(quickActionDetails).applyLink
                  : `mailto:${
                      _unref(quickActionDetails).type === 'workbean' && _unref(quickActionDetails).applyLink.length ? _unref(quickActionDetails).applyLink : ownerEmail.value
                    }?subject=💼 I'm applying for your ${_unref(quickActionDetails).job.replace(/\&/g, 'and').replace(/\//g, ' or ')} role`,
                '_blank'
              )
            ))
              }, {
                default: _withCtx(() => [
                  _hoisted_31,
                  _createTextVNode(" Apply now")
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                class: "text-primary-black bg-white font-bold rounded-[4px] shadow-base",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (seeCompanyPage(`/company/${_unref(companyDetails).slug}`)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Culture page")
                ]),
                _: 1
              })
            ])
          ], 4)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})